import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ICompanies {
  id: number;
  name: string;
  provider: string;
}

interface ISmsProvidersData {
  list?: Array<ICompanies>;
  pageNo: number;
  pageSize: number;
  searchKey?: string;
  totalCount?: number;
  message?: { text: string; type: string };
}

const initialState: ISmsProvidersData = {
  pageNo: 1,
  pageSize: 20,
  searchKey: "",
  list: [],
  totalCount: 0,
  message: { text: "", type: "success" },
};

const smsProvidersSlice = createSlice({
  name: "sms_providers",
  initialState,
  reducers: {
    setSmsProvidersList: (state, _action: PayloadAction<ISmsProvidersData>) => {
      state.list = _action.payload.list;
      state.pageNo = _action.payload.pageNo;
      state.pageSize = _action.payload.pageSize;
      state.totalCount = _action.payload.totalCount;
    },
    resetSmsProvidersToInit: (state) => {
      state = initialState;
    },
    setSmsProvidersMessages: (
      state,
      _action: PayloadAction<{ text: string; type: string }>
    ) => {
      state.message = _action.payload;
    },
  },
});

export const {
  setSmsProvidersList,
  resetSmsProvidersToInit,
  setSmsProvidersMessages,
} = smsProvidersSlice.actions;

export default smsProvidersSlice.reducer;
